
<div class="row detail_row">
    <div class="col col-6 detail_row_header">
        <slot name="header"></slot>
    </div>
    <div class="col col-6">
        <slot name="content"></slot>
    </div>
</div>
